export const FacebookIcon = () => (
	<svg
		id="g538"
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 23.244 23.068"
	>
		<path
			id="path540"
			d="M-238.151,0a11.622,11.622,0,0,0-11.622,11.622,11.623,11.623,0,0,0,9.617,11.446v-.04h0v-8.2h-2.8V11.621h2.8V9.062a4.345,4.345,0,0,1,4.578-4.653,20.218,20.218,0,0,1,2.635.209v3h-1.5c-1.443,0-1.705.909-1.705,1.828v2.179h3.206l-.561,3.207h-2.645v8.24a11.623,11.623,0,0,0,9.618-11.446A11.622,11.622,0,0,0-238.151,0"
			transform="translate(249.773)"
			fill="#707070"
		/>
	</svg>
);
